import React from "react";
import MicroApp from "@/components/micro-app";
import env from "@/env";

export default function ActivityData() {
  return <MicroApp url={`${env.CELUE_DOMAIN}/microapp`} name="celuedata" />;
}
